import { render, staticRenderFns } from "./ServiceDetailsPage.vue?vue&type=template&id=b2364a00&"
import script from "./ServiceDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports